<template>
  <section class="bg">

    <Header page="questions" :title="surveyTitle" />

    <!-- Recent Answers Section -->
    <div v-if="survey && survey.questions && (survey.questions[0] && survey.questions[0].answer_count) || (survey.questions[1] && survey.questions[1].answer_count) || (survey.questions[2] && survey.questions[2].answer_count)" class="recent-answers-container" :class="{ nps: is_nps_survey }">

      <!-- Recent Answer options -->
      <div class="top-row-buttons">
        <h2>{{ !is_nps_survey ? 'Latest Responses' : '' }}</h2>
        <div>
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item @click="exportCSV()">Answers CSV</a-menu-item>
              <a-menu-item @click="exportJSON()">Answers JSON</a-menu-item>
              <a-menu-item @click="exportMedia()" v-if="is_media_answers_in_survey">Media Files</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px">Export <a-icon type="down" /> </a-button>
          </a-dropdown>
          <a-button @click="go_to_all_respondents_page">All Respondents<a-icon type="right" /></a-button>
        </div>
      </div>

      <!-- Recent Answer Loading -->
      <div v-if="!recent_answers && !is_nps_survey" class="loading">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
        </a-spin>
      </div>

      <!-- Recent Answer Cards -->
      <template v-for="recent_answer of recent_answers" v-if="!is_nps_survey">

        <div
        class="recent-answer"
        :key="recent_answer.id"
        :style="{ backgroundImage: `url(${recent_answer.profile_pic})` }"
        @click="go_to_respondent_page(recent_answer.uid)">
          <div class="shadow"></div>
          <p class="name">{{ recent_answer.uid }}</p>
          <p class="time-added">{{ getTimeAgo(recent_answer.time_created) }}</p>
        </div>

      </template>

      <!-- NPS Card -->
      <NPSCard :nps_data="survey.nps" v-if="is_nps_survey" />

    </div>

    <!-- Question Cards -->
    <div v-if="survey" class="question-card-container">
      <div v-for="(question, name, question_index) in survey.questions" :key="question_index" @click="go_to_answers_page(question_index, (question.answer_type === 'say'))">
        <p class="answer-type-icon">{{ get_answer_type_icon(question.answer_type) }}️</p>
        <h3 v-bind:title="question.text">{{ question_index + 1 }}. {{ question.text.en || question.text }}</h3>
        <h4 v-if="question.answer_type !== 'say'">{{ question.answer_count || 0 }} {{ question.answer_count === 1 ? 'Answer' : 'Answers'}}</h4>
      </div>
    </div>

    <!-- Question Cards Loading -->
    <div v-if="surveyTitle == ''" class="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
      </a-spin>
    </div>

  </section>
</template>


<script>
import moment from 'moment';
import { db_helper } from '../store/db_helper.js';
import { nps_helper } from '../store/nps_helper.js';
import _ from 'lodash';
import Header from '@/components/Header.vue'
import NPSCard from '@/components/nps/NPSCard.vue'
const { parse } = require('json2csv');

export default {
  name: 'questions',
  components: {
    Header,
    NPSCard
  },
  data: function () {
    return {}
  },
  computed: {
    recent_answers() {
      let surveys = this.$store.state.surveys;
      if (!surveys) { return null };
      return surveys[this.$route.params.survey_index].recent_answers;
    },
    survey() {
      if (!_.isEmpty(this.$store.state.surveys)) {
        return this.$store.state.surveys[this.$route.params.survey_index];
      } else {
        return {};
      };
    },
    surveyTitle() {
      return this.survey && this.survey.title ? this.survey.title : "";
    },
    is_media_answers_in_survey() {
      let is_media = false;
      for (const question_index in this.survey.questions) {
        let question = this.survey.questions[question_index];
        if (['audio', 'video', 'image'].includes(question.answer_type)) {
          is_media = true;
        };
      };
      return is_media;
    },

    is_nps_survey() {
      return nps_helper.is_nps_survey(this.survey);
    },

  },
  methods: {
    get_answer_type_icon(answer_type) {
      switch (answer_type) {
        case 'text':
          return '✏️';
        case 'audio':
          return '🎙';
        case 'image':
          return '📷';
        case 'video':
          return '🎬';
        case 'multimedia':
          return '▶️';
        case 'multi_choice':
          return '📊';
        case 'location':
          return '📍';
        case 'nps':
          return '⚖️';
        case 'say':
          return '💬';
        default:
          return '';
      };
    },
    getTimeAgo(unix) {
      return moment.unix(unix).fromNow();
    },

    go_to_answers_page(question_index, is_say) {
      if (!is_say) {
        this.$router.push({ name: 'answers', params: { question_index } })
        analytics.track('Question Card Clicked');
      };
    },

    go_to_respondent_page(uid) {
      this.$router.push({ name: 'respondent', params: { uid } })
      analytics.track('Recent Answer Card Clicked');
    },

    go_to_all_respondents_page() {
      this.$router.push({ name: 'respondents' })
      analytics.track('All Respondents Button Clicked');
    },

    exportCSV: async function() {
      let [formatted_answers, keys] = await db_helper.getFormattedSurveyCSV(this.survey);
      const fields = keys;
      const opts = { fields };
      const csv = parse(formatted_answers, opts);
      var dataStr = "data:text/csv;charset=UTF-8," + encodeURIComponent(csv);
      var downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", "survey_data.csv");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },

    exportJSON: async function() {
      let formatted_answers = await db_helper.getFormattedSurveyJSON(this.survey);
      var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(formatted_answers));
      var downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", "survey_data.json");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },

    exportMedia: async function() {
      const hide = this.$message.loading('Zipping Media Files', 0);
      let content = await db_helper.exportMedia(this.survey);
      if (content) { // No media to download
        this.$saveAs(content, `${this.survey.title}-media.zip`);
        setTimeout(hide, 5000);
      } else {
        hide();
        this.$message.warning('No media to download (photos, video & audio)', 5);
      };
    },

  },

  mounted() {

    window.scrollTo(0, 0);

    let survey_index = this.$route.params.survey_index;
    let surveys = this.$store.state.surveys;

    if (!surveys) { // User has not yet been inited - the page was loaded directly.
      var that = this;
      // TODO: Set a series of setTimeouts, which are cleared if an earlier one fires
      // Give the app 4 second to re-auth the user, otherwise take them back to surveys
      setTimeout(function() {
        if (!that.$store.state.surveys) {
          that.$router.replace('/surveys'); // User hasn't authed yet, and therefore survey id's haven't been set - ideally I wait and showing loading instead of redirecting..
        } else { // See if the surveys answers have been set yet, set them if not - this will likely be called everytime
          that.$store.dispatch('setRecentAnswers', survey_index);
        };
      }, 4000);

    } else {

      let survey = surveys[survey_index];
      this.$store.dispatch('setRecentAnswers', survey_index);

    };
  },

  created() {
    analytics.page('Questions');
  }

};
</script>

<style lang="scss" scoped>
section.bg{
  padding-bottom: 50px;
  background-image: linear-gradient(135deg, #eff0f3 1%,#fefeff 100%);
  min-height: 100%;
}
.recent-answers-container{
  height: 180px;
  width: 970px;
  margin: 0 auto;
  margin-top: 55px;
  &.nps{
    height: 280px;
  }
  div:first-of-type{
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }
  h2{
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    font-size: 18px;
  }
  .recent-answer{
    position: relative;
    display: inline-block;
    height: 125px;
    width: 79px;
    margin-right: 20px;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 6px;
    .shadow{
      position: absolute;
        top: 0;
        left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.2);
      transition: all 0.4s ease;
      cursor: pointer;
      &:hover{
        background-color: rgba(0,0,0,0);
      }
    }
    &:last-of-type{
      margin-right: 0;
    }
    p{
      color: white;
      position: absolute;
      font-weight: 500;
      margin-bottom: 0px;
    }
    .time-added{
      font-size: 8px;
      top: 8px;
      right: 6px;
    }
    .name{
      //font-size: 8px;
      font-size: 14px;
      bottom: 3px;
      left: 7px;
      max-width: 70px;
      overflow: auto;
      text-overflow: ellipsis;
    }
  }
}

.question-card-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  width: 1000px;
  margin: 0 auto;
  margin-top: 55px;
  font-family: "Montserrat", sans-serif;
  & > div{
    width: 310px;
    height: auto;
    padding: 24px;
    padding-bottom: 25px;
    margin: 10px;
    background-color: white;
    border: 1px solid #ECECEC;
    border-radius: 6px;
    box-shadow: 0 0 8px 0 rgba(0,0,0,.08);
    h3, h4, p{
      &:hover{
        cursor: pointer;
      }
    }
    h3, h4{
      font-weight: 700;
      text-align: center;
    }
    h3{
      font-size: 16px;
      color: #0D303F;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }
    h4{
      font-size: 14px;
      color: #1BD285;
      margin-top: 15px;
    }
    p{
      font-size: 30px;
      text-align: center;
      margin: -4px 0 10px 0;
    }
    .answer-type-icon{
      color: rgb(0,0,0);
    }
  }
}
.ant-btn{
  font-family:'Montserrat';
  color: #0D303F;
  font-size: 14px;
  font-weight: 600;
  margin-left: 12px;
  &:hover{
    border-color: #1BD285;
  }
  &:active{
    border-color: #1BD285;
  }
  &:focus{
    border-color: #1BD285;
  }
}
.loading{
  height: 40px;
  width: 40px;
  margin: 0 auto;
  margin-top: 105px;
  display: block;
}
.recent-answers-container .loading{
  margin-top: 55px;
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.recent-answers-container{
  width: 100%;
  height: 50px;
  padding: 20px;
  margin-top: 30px;
  margin-bottom: -30px;
  .recent-answer{
    display: none;
  }
}

.question-card-container{
  width: 100%;
  padding: 20px;
  & > div{
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
  }
}

.top-row-buttons{
  justify-content: center !important;
  h2{
    display: none;
  }
  div{
    button{
      display: none;
    }
    button:last-of-type{
      display: block;
    }
  }
}
}

/* Ipad Portrait */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .recent-answers-container{
    width: 95%;
    height: 50px;
    padding: 20px;
    margin-top: 30px;
    margin-bottom: -30px;
    .recent-answer{
      display: none;
    }
  }
  .question-card-container{
    width: 100%;
    padding: 20px;
    & > div{
      width: 45%;
      margin-left: 2%;
      margin-right: 2%;
    }
  }
}


</style>
